/** @format */

import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { DocumentsContainer } from './containers';
import { updateBodyClass } from 'src/helpers';
import { BODY_CLASSES } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import withRouter from 'src/utils/withRouter';

const DocumentsContainerWithRouter = withRouter(DocumentsContainer);

class DocumentsRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.CASES);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.CASES);
  }
  render() {
    return (
      <Layout headerName={'Case Management'}>
        <Suspense fallback={<ServiceSpinner open={true} />}>
          <Routes>
            <Route path={'*'} element={<DocumentsContainerWithRouter />} />
          </Routes>
        </Suspense>
      </Layout>
    );
  }
}

export default DocumentsRoot;
